import React from "react"
import styles from "./Home.module.css"
import scrollTo from "gatsby-plugin-smoothscroll"
import { FaChevronDown } from "react-icons/fa"
import { graphql, StaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Div100vh from "react-div-100vh"
import logo from "../../images/logo.png"

const Home = () => {
  return (
    <StaticQuery
      query={graphql`
        query HomeBackground {
          homeBackground: file(relativePath: { eq: "background.jpg" }) {
            childImageSharp {
              fluid(quality: 100, maxWidth: 5000, maxHeight: 3000) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
      render={data => {
        const imageData = data.homeBackground.childImageSharp.fluid
        return (
          <Div100vh className={styles.container} id="home-page">
            <div className={styles.overlay}></div>
            <BackgroundImage
              Tag="div"
              fluid={imageData}
              className={styles.background}
              style={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "",
                backgroundColor: "#444 ",
              }}
            />
            <div className={styles.content}>
              <img className={styles.logo} src={logo} alt="logo" />
              <div className={styles.description}>
                <h1 className={styles.title1}>RIGHT CHOICE RENOVATIONS</h1>
                <div className={styles.line}>&nbsp;</div>
                <h1 className={styles.title2}>Quality woodworking and renovations</h1>
              </div>
              <div className={styles.buttons}>
                <button onClick={() => scrollTo("#about-page")} className={styles.aboutBtn}>
                  Learn More
                </button>
                <button onClick={() => scrollTo("#contact-page")} className={styles.contactBtn}>
                  Request Quote
                </button>
              </div>
            </div>
            <FaChevronDown className={styles.downArrow} onClick={() => scrollTo("#about-page")} />
          </Div100vh>
        )
      }}
    />
  )
}

export default Home
